import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'

import {
  Card,
  Table,
  Button,
  Select,
  Collapse,
  Row,
  Col,
  Form,
  message,
  Spin,
  DatePicker,
  Radio
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import ProductImg from '../../../assets/images/product-details.png'
import { useHistory } from 'react-router-dom'
import { faRecordVinyl } from '@fortawesome/free-solid-svg-icons'
import { cpuUsage } from 'process'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { PRODUCT_SCREEN, REPORTS_DASHBOARD } from '../../../constants/Pages'
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  ComposedChart,
  Line
} from 'recharts'
import {
  formatDigits,
  isEmptyObject,
  StringIsNullOrEmpty,
  getDecryptID,
  checkRightspermissions
} from '../../../appRedux/actions/GlobalMethods'
import Widget from '../../../components/Widget'
import Auxiliary from '../../../util/Auxiliary'
import moment from 'moment'
import {
  loadCalculateComparison,
  loadSpecifiedDateRangeData
} from '../../../appRedux/actions/Reports'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const viewByOptions = [
  { label: 'Day', value: '29' },
  { label: 'Week', value: '32' },
  { label: 'Month', value: '26' }
]

const ReportMeasures = {
  AvgItemperSale: 3,
  AvgSaleValue: 4,
  AvgSaleValueInclTax: 5,
  CostofGoodsSold: 6,
  CustomerCount: 7,
  Discounted: 8,
  DiscountedPercentage: 9,
  FirstSale: 10,
  ItemSold: 11,
  LastSale: 12,
  MarginPercentage: 13,
  ReturnCount: 14,
  ReturnsPercentage: 15,
  Revenue: 16,
  RevenueInclTax: 17,
  SaleCount: 18,
  SaleswithCustomerPercentage: 19,
  Tax: 20,
  GrossProfit: 51
}

const dateFormat = 'YYYY-MM-DD'

const RetailDashboardListing = ({ location, match }) => {
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  //#region  for use State

  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencyName: '',
    currencySymbol: ''
  })
  const [getDefaultDecimalPlaces, setDefaultDecimalPlace] = React.useState(2) //api me isko db sy update rakhna hy
  const [getRevenueData, setRevenueData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })
  const [getSalesCountData, setSalesCountData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })
  const [getGrossProftData, setGrossProftData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })
  const [getDiscountData, setDiscountData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })

  const [getDiscountedPercentageData, setDiscountedPercentageData] =
    React.useState({
      TotalValue: '0',
      LineChartsData: [],
      BarChartsData: []
    })

  const [getAverageSaleData, setAverageSaleData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })

  const [getAverageItemPerSaleData, setAverageItemPerSaleData] = React.useState(
    {
      TotalValue: '0',
      LineChartsData: [],
      BarChartsData: []
    }
  )

  const [getCustomerCountData, setCustomerCountData] = React.useState({
    TotalValue: '0',
    LineChartsData: [],
    BarChartsData: []
  })
  const [getProductSoldColumns, setProductSoldColumns] = React.useState([])
  const [getProductSoldData, setProductSoldData] = React.useState([])

  const [getTopSalesColumns, setTopSalesColumns] = React.useState([])
  const [getTopSalesData, setTopSalesData] = React.useState([])

  const [getLoader, setLoader] = React.useState(true)
  const [getPeriodName, setPeriodName] = React.useState('Day')
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  //#endregion for use State

  //#region  for use Selector

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getReduxSpecifiedDateRangeData = useSelector(
    ({ Reports }) => Reports.specifiedDateRangeData
  )
  const getReduxCalculated = useSelector(
    ({ Reports }) => Reports.getCalculatedComparison
  )
  const getReduxComparisonDateData = useSelector(
    ({ Reports }) => Reports.comparisonDateData
  )
  //#endregion use Selector Region

  //#region  for use Effect

  // console.log("GET Store Outlets : " ,getReduxStoreOutlets);
  //for common data -> store currency
  React.useEffect(() => {
    const commonData = getReduxCommonSetting
    if (
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.currencyData
    ) {
      let currencyData = commonData.storeCommonConfigs.storeConfig.currencyData
      // setCurrSymbol(currencyData.currencySymbol);
      // setShortCurr(currencyData.currencyCode);
      setCurrData(currencyData)
    }

    // rights && permissions
    if (commonData && commonData.storeCommonConfigs) {
      const rpData = checkRightspermissions(commonData)
      if (rpData && !isEmptyObject(rpData)) {
        setupRightsPermissions(rpData)
        setAccessLoading(false)
      } else {
        toInitialState()
        setAccessLoading(false)
      }
    }
  }, [getReduxCommonSetting])
  React.useEffect(() => {
    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'report.retail.dashboard')
    }
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(REPORTS_DASHBOARD))
      const body = {
        dateTimeTo: moment().format(dateFormat),
        periodId:
          form.getFieldValue('PeriodID') &&
          form.getFieldValue('PeriodID') != undefined
            ? form.getFieldValue('PeriodID')
            : '29',
        outlet: form.getFieldValue('Outlet')
          ? form.getFieldValue('Outlet') == '0'
            ? 'ALL'
            : form.getFieldValue('Outlet')
          : 'ALL'
      }

      getBIDashboardReports(body)
    }

    return () => (mounted = false)
  }, [])

  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     if (Object.keys(getReduxCommonSetting).length === 0) {
  //       dispatch(setCommonConfigs(PRODUCT_SCREEN));
  //     }
  //   }

  //   return () => (mounted = false);
  // }, []);

  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     let commonData = getReduxCommonSetting;
  //     if (
  //       commonData.storeCommonConfigs &&
  //       commonData.storeCommonConfigs.storeConfig &&
  //       commonData.storeCommonConfigs.storeConfig.currencyData
  //     ) {
  //       let currencyData =
  //         commonData.storeCommonConfigs.storeConfig.currencyData;
  //       // setCurrSymbol(currencyData.currencySymbol);
  //       // setShortCurr(currencyData.currencyCode);
  //       setCurrData(currencyData);
  //     }
  //   }

  //   return () => (mounted = false);
  // }, [getReduxCommonSetting]);
  //#endregion for use Effect

  function setupRightsPermissions (rpData) {
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
  }

  function toInitialState () {
    setIsAllowRead(false)
  }

  //#region Api Services
  async function getBIDashboardReports (body) {
    setLoader(true)
    if (form.getFieldValue('PeriodID')) {
      if (form.getFieldValue('PeriodID') == '29') {
        setPeriodName('Day')
      }
      if (form.getFieldValue('PeriodID') == '32') {
        setPeriodName('Week')
      }
      if (form.getFieldValue('PeriodID') == '26') {
        setPeriodName('Month')
      }
    } else {
      setPeriodName('Day')
      form.setFieldsValue({ PeriodID: '29' })
    }

    const getReports = ds.getBIRetailsReportsService(body, BEHAVIOUR_TYPE.GET)
    await getReports
      .then(res => {
        setLoader(false)
        if (res) {
          const getSpecDate = localStorage.getItem('specDate')
            ? JSON.parse(localStorage.getItem('specDate'))
            : false
          if (getSpecDate) {
            dispatch(loadSpecifiedDateRangeData(getSpecDate))
          }
          const data = res.data
          let periodData = []

          let revenueTotal = '0'
          let salesTotal = '0'
          let customerTotal = '0'
          let grossProfitTotal = '0'
          let discountTotal = '0'
          let discountPercentageTotal = '0'
          let averageSaleTotal = '0'
          let averageItemPerSaleTotal = '0'

          let revenuePrevious = '0'
          let salesPrevious = '0'
          let customerPrevious = '0'
          let grossProfitPrevious = '0'
          let discountPrevious = '0'
          let discountPercentagePrevious = '0'
          let averageSalePrevious = '0'
          let averageItemPerSalePrevious = '0'

          let revenueLineChartsData = []
          let revenueBarChartsData = []

          try {
            periodData = JSON.parse(res.data.periodData)
          } catch (e) {
            periodData = []
          }
          if (periodData.length > 0) {
            //#region Revenue Card
            try {
              let revenueBarData = JSON.parse(res.data.revenueBarData)
              if (revenueBarData != null) {
                if (revenueBarData.length > 0) {
                  revenueBarChartsData = BarChartsJsonBuilder(revenueBarData)
                }
              }
            } catch (e) {
              revenueBarChartsData = []
              // message.error("Revenue Bar Charts Data Parsing Issue");
            }

            try {
              let revenueHistoryData = JSON.parse(res.data.revenueHistoryData)

              if (revenueHistoryData != null) {
                if (revenueHistoryData.length > 0) {
                  revenueLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    revenueHistoryData
                  )
                }
              }
            } catch (e) {
              revenueLineChartsData = []

              // message.error("Revenue Line Charts Data Parsing Issue");
            }
            try {
              let revenueTotalParse = JSON.parse(res.data.revenueTotal)
              // // revenueTotal = revenueTotalParse[0]["[Measures].[Revenue]"];
              // revenueTotal = JSON.stringify(revenueTotalParse[0]).split(':')[1].replace("}",'').replace(/(^"|"$)/g, ''); //alternative
              // revenuePrevious =
              //   revenueTotalParse[0]["[Measures].[PrevDayRev(%)]"] != null
              //     ? revenueTotalParse[0]["[Measures].[PrevDayRev(%)]"]
              //     : 0;

              let revenueObj = Object.keys(revenueTotalParse[0]).map(key => [
                key,
                revenueTotalParse[0][key]
              ])
              if (revenueObj && revenueObj != null && revenueObj.length > 0) {
                revenueTotal =
                  revenueObj[0] != null &&
                  revenueObj[0] != undefined &&
                  revenueObj[0].length > 0
                    ? revenueObj[0][1] != null
                      ? revenueObj[0][1]
                      : '0'
                    : '0'
                revenuePrevious =
                  revenueObj[1] != null &&
                  revenueObj[1] != undefined &&
                  revenueObj[1].length > 0
                    ? revenueObj[1][1] != null
                      ? revenueObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              // message.error("Revenue Total Count Parsing Issue");
              revenueTotal = '0'
              revenuePrevious = '0'
            }
            let revenueData = {
              TotalValue: revenueTotal
                ? parseFloat(revenueTotal).toFixed(getDefaultDecimalPlaces) !=
                  'NaN'
                  ? parseFloat(revenueTotal).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: revenuePrevious
                ? parseFloat(revenuePrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(revenuePrevious).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: revenueLineChartsData,
              BarChartsData: revenueBarChartsData
            }
            setRevenueData(revenueData)

            //#endregion Revenue Card

            //#region Sales Count Card
            let salesCountLineChartsData = []
            let salesCountBarChartsData = []

            try {
              let salesCountBarData = JSON.parse(res.data.salesCountBarData)
              if (salesCountBarData != null) {
                if (salesCountBarData.length > 0) {
                  salesCountBarChartsData =
                    BarChartsJsonBuilder(salesCountBarData)
                }
              }
            } catch (e) {
              salesCountBarChartsData = []
              // //message.error("Sales Count Bar Chart Data Parsing Issue");
            }
            try {
              let salesCountHistoryData = JSON.parse(
                res.data.salesCountHistoryData
              )
              if (salesCountHistoryData != null) {
                if (salesCountHistoryData.length > 0) {
                  salesCountLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    salesCountHistoryData
                  )
                }
              }
            } catch (e) {
              salesCountLineChartsData = []
              //message.error("Sales Count Line Chart Data Parsing Issue");
            }

            try {
              let salesTotalParse = JSON.parse(res.data.salesTotal)
              // salesTotal = salesTotalParse[0]["[Measures].[Sale Count]"];
              // salesPrevious =
              //   salesTotalParse[0]["[Measures].[PrevDaySaleCount(%)]"] != null
              //     ? salesTotalParse[0]["[Measures].[PrevDaySaleCount(%)]"]
              //     : 0;
              let salesTotalObj = Object.keys(salesTotalParse[0]).map(key => [
                key,
                salesTotalParse[0][key]
              ])
              if (
                salesTotalObj &&
                salesTotalObj != null &&
                salesTotalObj.length > 0
              ) {
                salesTotal =
                  salesTotalObj[0] != null &&
                  salesTotalObj[0] != undefined &&
                  salesTotalObj[0].length > 0
                    ? salesTotalObj[0][1] != null
                      ? salesTotalObj[0][1]
                      : '0'
                    : '0'
                salesPrevious =
                  salesTotalObj[1] != null &&
                  salesTotalObj[1] != undefined &&
                  salesTotalObj[1].length > 0
                    ? salesTotalObj[1][1] != null
                      ? salesTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("Sales Total Count Parsing Issue");
              salesTotal = '0'
              salesPrevious = '0'
            }

            let salesCountData = {
              TotalValue: salesTotal
                ? parseFloat(salesTotal).toFixed(getDefaultDecimalPlaces) !=
                  'NaN'
                  ? parseFloat(salesTotal).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: salesPrevious
                ? parseFloat(salesPrevious).toFixed(getDefaultDecimalPlaces) !=
                  'NaN'
                  ? parseFloat(salesPrevious).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: salesCountLineChartsData,
              BarChartsData: salesCountBarChartsData
            }
            setSalesCountData(salesCountData)

            //#endregion Sales Count Card

            //#region Customer Count Card
            let customerCountLineChartsData = []
            let customerCountBarChartsData = []

            try {
              let customerCountBarData = JSON.parse(res.data.customerBarData)
              if (customerCountBarData != null) {
                if (customerCountBarData.length > 0) {
                  customerCountBarChartsData =
                    BarChartsJsonBuilder(customerCountBarData)
                }
              }
            } catch (e) {
              customerCountBarChartsData = []
              //message.error("Customer Count Bar Data Parsing Issue");
            }

            try {
              let customerCountHistoryData = JSON.parse(
                res.data.customerHistoryData
              )
              if (customerCountHistoryData != null) {
                if (customerCountHistoryData.length > 0) {
                  customerCountLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    customerCountHistoryData
                  )
                }
              }
            } catch (e) {
              customerCountLineChartsData = []
              //message.error("Customer Count Line Chart Data Parsing Issue");
            }

            try {
              let customerTotalParse = JSON.parse(res.data.customerTotal)
              // customerTotal =
              //   customerTotalParse[0]["[Measures].[Customer Count]"];
              // customerPrevious =
              //   customerTotalParse[0]["[Measures].[PrevDayCustomerCount(%)]"] !=
              //   null
              //     ? customerTotalParse[0][
              //         "[Measures].[PrevDayCustomerCount(%)]"
              //       ]
              //     : 0;

              let customerTotalObj = Object.keys(customerTotalParse[0]).map(
                key => [key, customerTotalParse[0][key]]
              )
              if (
                customerTotalObj &&
                customerTotalObj != null &&
                customerTotalObj.length > 0
              ) {
                customerTotal =
                  customerTotalObj[0] != null &&
                  customerTotalObj[0] != undefined &&
                  customerTotalObj[0].length > 0
                    ? customerTotalObj[0][1] != null
                      ? customerTotalObj[0][1]
                      : '0'
                    : '0'
                customerPrevious =
                  customerTotalObj[1] != null &&
                  customerTotalObj[1] != undefined &&
                  customerTotalObj[1].length > 0
                    ? customerTotalObj[1][1] != null
                      ? customerTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("Customer  Total Count Parsing Issue");
              customerTotal = '0'
              customerPrevious = '0'
            }

            let customerCountData = {
              TotalValue: customerTotal
                ? parseFloat(customerTotal).toFixed(getDefaultDecimalPlaces) !=
                  'NaN'
                  ? parseFloat(customerTotal).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: customerPrevious
                ? parseFloat(customerPrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(customerPrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: customerCountLineChartsData,
              BarChartsData: customerCountBarChartsData
            }
            setCustomerCountData(customerCountData)

            //#endregion Customer Count Card

            //#region GROSS PROFIT Card
            let grossProfitLineChartsData = []
            let grossProfitBarChartsData = []

            try {
              let grossProfitBarData = JSON.parse(res.data.grossProfitBarData)
              if (grossProfitBarData != null) {
                if (grossProfitBarData.length > 0) {
                  grossProfitBarChartsData =
                    BarChartsJsonBuilder(grossProfitBarData)
                }
              }
            } catch (e) {
              grossProfitBarChartsData = []
              //message.error("Gross Profit Bar Chart Data Parsing Issue");
            }
            try {
              let grossProfitHistoryData = JSON.parse(
                res.data.grossProfitHistoryData
              )
              if (grossProfitHistoryData != null) {
                if (grossProfitHistoryData.length > 0) {
                  grossProfitLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    grossProfitHistoryData
                  )
                }
              }
            } catch (e) {
              grossProfitLineChartsData = []
              //message.error("Gross Profit Line Chart Data Parsing Issue");
            }
            try {
              let grossprofiTotalParse = JSON.parse(res.data.grossProfitTotal)
              // grossProfitTotal =
              //   grossprofiTotalParse[0]["[Measures].[Gross Profit]"];
              // grossProfitPrevious =
              //   grossprofiTotalParse[0]["[Measures].[PrevDayGrossProfit(%)]"] !=
              //   null
              //     ? grossprofiTotalParse[0][
              //         "[Measures].[PrevDayGrossProfit(%)]"
              //       ]
              //     : 0;
              let grossProfitTotalObj = Object.keys(
                grossprofiTotalParse[0]
              ).map(key => [key, grossprofiTotalParse[0][key]])
              if (
                grossProfitTotalObj &&
                grossProfitTotalObj != null &&
                grossProfitTotalObj.length > 0
              ) {
                grossProfitTotal =
                  grossProfitTotalObj[0] != null &&
                  grossProfitTotalObj[0] != undefined &&
                  grossProfitTotalObj[0].length > 0
                    ? grossProfitTotalObj[0][1] != null
                      ? grossProfitTotalObj[0][1]
                      : '0'
                    : '0'
                grossProfitPrevious =
                  grossProfitTotalObj[1] != null &&
                  grossProfitTotalObj[1] != undefined &&
                  grossProfitTotalObj[1].length > 0
                    ? grossProfitTotalObj[1][1] != null
                      ? grossProfitTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("Gross Profit Count Parsing Issue");
              grossProfitTotal = '0'
              grossProfitPrevious = '0'
            }

            let grossProfitData = {
              TotalValue: grossProfitTotal
                ? parseFloat(grossProfitTotal).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(grossProfitTotal).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: grossProfitPrevious
                ? parseFloat(grossProfitPrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(grossProfitPrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: grossProfitLineChartsData,
              BarChartsData: grossProfitBarChartsData
            }
            setGrossProftData(grossProfitData)

            //#endregion Gross Profit Card

            //#region Discounted Card
            let discountedLineChartsData = []
            let discountedBarChartsData = []

            try {
              let discountBarData = JSON.parse(res.data.discountBarData)
              if (discountBarData != null) {
                if (discountBarData.length > 0) {
                  discountedBarChartsData =
                    BarChartsJsonBuilder(discountBarData)
                }
              }
            } catch (e) {
              discountedBarChartsData = []
              //message.error("Discount  Bar Chart Data Parsing Issue");
            }

            try {
              let discountHistoryData = JSON.parse(res.data.discountHistoryData)
              if (discountHistoryData != null) {
                if (discountHistoryData.length > 0) {
                  discountedLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    discountHistoryData
                  )
                }
              }
            } catch (e) {
              discountedLineChartsData = []
              //message.error("Discount Line Charts Data Parsing Issue");
            }

            try {
              let discountTotalParse = JSON.parse(res.data.discountTotal)
              // discountTotal = discountTotalParse[0]["[Measures].[Discounted]"];
              // discountPrevious =
              //   discountTotalParse[0]["[Measures].[PrevDayDiscounted(%)]"] !=
              //   null
              //     ? discountTotalParse[0]["[Measures].[PrevDayDiscounted(%)]"]
              //     : 0;

              let discountTotalObj = Object.keys(discountTotalParse[0]).map(
                key => [key, discountTotalParse[0][key]]
              )
              if (
                discountTotalObj &&
                discountTotalObj != null &&
                discountTotalObj.length > 0
              ) {
                discountTotal =
                  discountTotalObj[0] != null &&
                  discountTotalObj[0] != undefined &&
                  discountTotalObj[0].length > 0
                    ? discountTotalObj[0][1] != null
                      ? discountTotalObj[0][1]
                      : '0'
                    : '0'
                discountPrevious =
                  discountTotalObj[1] != null &&
                  discountTotalObj[1] != undefined &&
                  discountTotalObj[1].length > 0
                    ? discountTotalObj[1][1] != null
                      ? discountTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("  Discounted  Parsing Issue");
              discountTotal = '0'
              discountPrevious = '0'
            }

            let discountData = {
              TotalValue: discountTotal
                ? parseFloat(discountTotal).toFixed(getDefaultDecimalPlaces) !=
                  'NaN'
                  ? parseFloat(discountTotal).toFixed(getDefaultDecimalPlaces)
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: discountPrevious
                ? parseFloat(discountPrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(discountPrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: discountedLineChartsData,
              BarChartsData: discountedBarChartsData
            }
            setDiscountData(discountData)

            //#endregion Discount Card

            //#region Discounted Percentage Card
            let discountedPercentageLineChartsData = []
            let discountedPercentageBarChartsData = []

            try {
              let discountPercentagBarData = JSON.parse(
                res.data.discountPercentageBarData
              )
              if (discountPercentagBarData != null) {
                if (discountPercentagBarData.length > 0) {
                  discountedPercentageBarChartsData = BarChartsJsonBuilder(
                    discountPercentagBarData
                  )
                }
              }
            } catch (e) {
              discountedPercentageBarChartsData = []
              //message.error("Discount Bar Chart Percetage Data Parsing Issue");
            }

            try {
              let discountPercentageHistoryData = JSON.parse(
                res.data.discountPercentageHistoryData
              )
              if (discountPercentageHistoryData != null) {
                if (discountPercentageHistoryData.length > 0) {
                  discountedPercentageLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    discountPercentageHistoryData
                  )
                }
              }
            } catch (e) {
              discountedPercentageLineChartsData = []
              // message.error(
              //   "Discount Line Charts Percetage Data Parsing Issue"
              // );
            }

            try {
              let discountPercentageTotalParse = JSON.parse(
                res.data.discountPercentageTotal
              )
              // discountPercentageTotal =
              //   discountPercentageTotalParse[0]["[Measures].[Discounted (%)]"];
              // discountPercentagePrevious =
              //   discountPercentageTotalParse[0][
              //     "[Measures].[PrevDayDiscounted(%)(%)]"
              //   ] != null
              //     ? discountPercentageTotalParse[0][
              //         "[Measures].[PrevDayDiscounted(%)(%)]"
              //       ]
              //     : 0;

              let discountPercentageTotalObj = Object.keys(
                discountPercentageTotalParse[0]
              ).map(key => [key, discountPercentageTotalParse[0][key]])
              if (
                discountPercentageTotalObj &&
                discountPercentageTotalObj != null &&
                discountPercentageTotalObj.length > 0
              ) {
                discountPercentageTotal =
                  discountPercentageTotalObj[0] != null &&
                  discountPercentageTotalObj[0] != undefined &&
                  discountPercentageTotalObj[0].length > 0
                    ? discountPercentageTotalObj[0][1] != null
                      ? discountPercentageTotalObj[0][1]
                      : '0'
                    : '0'
                discountPercentagePrevious =
                  discountPercentageTotalObj[1] != null &&
                  discountPercentageTotalObj[1] != undefined &&
                  discountPercentageTotalObj[1].length > 0
                    ? discountPercentageTotalObj[1][1] != null
                      ? discountPercentageTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("Discounted  Percetage Parsing Issue");
              discountPercentageTotal = '0'
              discountPercentagePrevious = '0'
            }

            let discountPercentageData = {
              TotalValue: discountPercentageTotal
                ? parseFloat(discountPercentageTotal).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(discountPercentageTotal).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: discountPercentagePrevious
                ? parseFloat(discountPercentagePrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(discountPercentagePrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: discountedPercentageLineChartsData,
              BarChartsData: discountedPercentageBarChartsData
            }
            setDiscountedPercentageData(discountPercentageData)

            //#endregion Discounted Percentage  Card

            //#region Average Sale Data Card
            let averageSaleLineChartsData = []
            let averageSaleBarChartsData = []

            try {
              let averageSaleBarData = JSON.parse(res.data.averageSaleBarData)
              if (averageSaleBarData != null) {
                if (averageSaleBarData.length > 0) {
                  averageSaleBarChartsData =
                    BarChartsJsonBuilder(averageSaleBarData)
                }
              }
            } catch (e) {
              averageSaleBarChartsData = []
              //message.error("Average Sale Bar Chart Data Parsing Issue");
            }
            try {
              let averageSaleHistoryData = JSON.parse(
                res.data.averageSaleHistoryData
              )
              if (averageSaleHistoryData != null) {
                if (averageSaleHistoryData.length > 0) {
                  averageSaleLineChartsData = LineChartsJsonBuilder(
                    periodData,
                    averageSaleHistoryData
                  )
                }
              }
            } catch (e) {
              averageSaleBarChartsData = []
              //message.error("Average Sale Line Chart Data Parsing Issue");
            }
            try {
              let averageSaleTotalParse = JSON.parse(res.data.averageSaleTotal)
              // averageSaleTotal =
              //   averageSaleTotalParse[0]["[Measures].[Avg Sale Value]"];
              // averageSalePrevious =
              //   averageSaleTotalParse[0][
              //     "[Measures].[PrevDayAVGSaleValue(%)]"
              //   ] != null
              //     ? averageSaleTotalParse[0][
              //         "[Measures].[PrevDayAVGSaleValue(%)]"
              //       ]
              //     : 0;
              let averageSaleTotalObj = Object.keys(
                averageSaleTotalParse[0]
              ).map(key => [key, averageSaleTotalParse[0][key]])
              if (
                averageSaleTotalObj &&
                averageSaleTotalObj != null &&
                averageSaleTotalObj.length > 0
              ) {
                averageSaleTotal =
                  averageSaleTotalObj[0] != null &&
                  averageSaleTotalObj[0] != undefined &&
                  averageSaleTotalObj[0].length > 0
                    ? averageSaleTotalObj[0][1] != null
                      ? averageSaleTotalObj[0][1]
                      : '0'
                    : '0'
                averageSalePrevious =
                  averageSaleTotalObj[1] != null &&
                  averageSaleTotalObj[1] != undefined &&
                  averageSaleTotalObj[1].length > 0
                    ? averageSaleTotalObj[1][1] != null
                      ? averageSaleTotalObj[1][1]
                      : '0'
                    : '0'
              }
            } catch (e) {
              //message.error("Average Sale Total Parsing Issue");
              averageSaleTotal = '0'
              averageSalePrevious = '0'
            }

            let averageSaleData = {
              TotalValue: averageSaleTotal
                ? parseFloat(averageSaleTotal).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(averageSaleTotal).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: averageSalePrevious
                ? parseFloat(averageSalePrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(averageSalePrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: averageSaleLineChartsData,
              BarChartsData: averageSaleBarChartsData
            }
            setAverageSaleData(averageSaleData)

            //#endregion Average Sale Data Card

            //#region Average Item Per Sale Data Card
            let averageItemPerSaleLineChartsData = []
            let averageItemPerSaleBarChartsData = []

            try {
              if (res.data.averageItemPerSaleBarData != null) {
                let averageItemPerSaleBarData = JSON.parse(
                  res.data.averageItemPerSaleBarData
                )
                if (averageItemPerSaleBarData != null) {
                  if (averageItemPerSaleBarData.length > 0) {
                    averageItemPerSaleBarChartsData = BarChartsJsonBuilder(
                      averageItemPerSaleBarData
                    )
                  }
                }
              } else {
                //message.error("Average item Per Sale Data null");
              }
            } catch (e) {
              averageItemPerSaleBarChartsData = []
              // message.error(
              //   "Average item Per Sale Bar Chart Data Parsing Issue"
              // );
            }
            try {
              if (res.data.averageItemPerSaleHistoryData != null) {
                let averageItemPerSaleHistoryData = JSON.parse(
                  res.data.averageItemPerSaleHistoryData
                )
                if (averageItemPerSaleHistoryData != null) {
                  if (averageItemPerSaleHistoryData.length > 0) {
                    averageItemPerSaleLineChartsData = LineChartsJsonBuilder(
                      periodData,
                      averageItemPerSaleHistoryData
                    )
                  }
                }
              } else {
                //message.error("Average item Per Sale Data null");
              }
            } catch (e) {
              averageItemPerSaleLineChartsData = []
              // message.error(
              //   "Average item Per Sale Line Chart Data Parsing Issue"
              // );
            }

            try {
              if (res.data.averageItemPerSaleTotal != null) {
                let averageItemPerSaleTotalParse = JSON.parse(
                  res.data.averageItemPerSaleTotal
                )
                // averageItemPerSaleTotal =
                //   averageItemPerSaleTotalParse[0][
                //     "[Measures].[Avg Item per Sale]"
                //   ];
                // averageItemPerSalePrevious =
                //   averageItemPerSaleTotalParse[0][
                //     "[Measures].[PrevDayAvgItemperSale(%)]"
                //   ] != null
                //     ? averageItemPerSaleTotalParse[0][
                //         "[Measures].[PrevDayAvgItemperSale(%)]"
                //       ]
                //     : 0;

                let averageItemPerSaleTotalObj = Object.keys(
                  averageItemPerSaleTotalParse[0]
                ).map(key => [key, averageItemPerSaleTotalParse[0][key]])
                if (
                  averageItemPerSaleTotalObj &&
                  averageItemPerSaleTotalObj != null &&
                  averageItemPerSaleTotalObj.length > 0
                ) {
                  averageItemPerSaleTotal =
                    averageItemPerSaleTotalObj[0] != null &&
                    averageItemPerSaleTotalObj[0] != undefined &&
                    averageItemPerSaleTotalObj[0].length > 0
                      ? averageItemPerSaleTotalObj[0][1] != null
                        ? averageItemPerSaleTotalObj[0][1]
                        : '0'
                      : '0'
                  averageItemPerSalePrevious =
                    averageItemPerSaleTotalObj[1] != null &&
                    averageItemPerSaleTotalObj[1] != undefined &&
                    averageItemPerSaleTotalObj[1].length > 0
                      ? averageItemPerSaleTotalObj[1][1] != null
                        ? averageItemPerSaleTotalObj[1][1]
                        : '0'
                      : '0'
                }
              } else {
                //message.error("Average item Per Sale Total Data null");
                averageItemPerSaleTotal = '0'
                averageItemPerSalePrevious = '0'
              }
            } catch (e) {
              //message.error("Average Item per  Sale Total Parsing Issue");
              averageItemPerSaleTotal = '0'
              averageItemPerSalePrevious = '0'
            }

            let averageItemPerSaleData = {
              TotalValue: averageItemPerSaleTotal
                ? parseFloat(averageItemPerSaleTotal).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(averageItemPerSaleTotal).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              PreviousValue: averageItemPerSalePrevious
                ? parseFloat(averageItemPerSalePrevious).toFixed(
                    getDefaultDecimalPlaces
                  ) != 'NaN'
                  ? parseFloat(averageItemPerSalePrevious).toFixed(
                      getDefaultDecimalPlaces
                    )
                  : parseFloat('0').toFixed(getDefaultDecimalPlaces)
                : parseFloat('0').toFixed(getDefaultDecimalPlaces),
              LineChartsData: averageItemPerSaleLineChartsData,
              BarChartsData: averageItemPerSaleBarChartsData
            }
            setAverageItemPerSaleData(averageItemPerSaleData)

            //#endregion Average  Item Per Sale Data Card
          }

          //#region Products Sold
          let productHeaders = []
          let productData = []
          try {
            productHeaders = JSON.parse(res.data.productHeaders)
            let productColumns = productHeaders.map(x => {
              let sorterdata = false
              if (x.Value == 'Revenue') {
                sorterdata = (a, b) => a.Revenue - b.Revenue
              }
              return {
                title: x.Value,
                dataIndex: x.Value,
                key: x.Value,
                sorter: sorterdata
              }
            })

            setProductSoldColumns(productColumns)
          } catch (e) {
            productHeaders = []
            setProductSoldColumns([])
          }

          if (productHeaders.length > 0) {
            try {
              productData = JSON.parse(res.data.productData)
              let dynamicProductData = []
              productData.map((x, index) => {
                const obj = Object.keys(productData[index]).map(
                  k => productData[index][k]
                )
                let jsonData = {}
                productHeaders.forEach(function (column, index1) {
                  var columName = column.Value
                  if (obj[index1].includes('¬~¬')) {
                    obj[index1] = GetReportDynamicLink('product', obj[index1])
                  } else {
                    if (
                      !Number.isNaN(parseInt(obj[index1])) &&
                      !obj[index1].includes('¬~¬')
                    ) {
                      obj[index1] = formatDigits(
                        obj[index1],
                        getDefaultDecimalPlaces
                      )
                    }
                    if (obj[index1].includes('¬~¬')) {
                      obj[index1] =
                        obj[index1] != null
                          ? obj[index1].includes('¬~¬')
                            ? obj[index1].split('¬~¬')[1]
                            : obj[index1]
                          : obj[index1]
                    }
                  }

                  jsonData[columName] = obj[index1]
                })
                dynamicProductData.push(jsonData)
              })
              setProductSoldData(dynamicProductData)
              // console.log("Product", dynamicProductData);
            } catch (e) {
              productData = []
              setProductSoldData([])
            }
          } else {
            setProductSoldData([])
          }
          //#endregion Products Sold

          //#region Top Sales People
          let topSalesHeader = []
          let topSalesData = []
          try {
            topSalesHeader = JSON.parse(res.data.userHeaders)
            let userColumns = topSalesHeader.map(x => {
              let sorterdata = false
              if (x.Value == 'Revenue') {
                sorterdata = (a, b) =>
                  a.Revenue.replace(',', '') - b.Revenue.replace(',', '')
              }

              return {
                title: x.Value,
                dataIndex: x.Value,
                key: x.Value,
                sorter: sorterdata
              }
            })
            setTopSalesColumns(userColumns)
          } catch (e) {
            topSalesHeader = []
            setTopSalesColumns([])
          }
          if (topSalesHeader.length > 0) {
            try {
              topSalesData = JSON.parse(res.data.userData)
              let dynamicSalesData = []
              topSalesData.map((x, index) => {
                const obj = Object.keys(topSalesData[index]).map(
                  k => topSalesData[index][k]
                )
                let jsonData = {}
                topSalesHeader.forEach(function (column, index1) {
                  var columName = column.Value
                  if (obj[index1] != null) {
                    if (obj[index1].includes('¬~¬')) {
                      obj[index1] = GetReportDynamicLink('user', obj[index1])
                    } else {
                      if (
                        !Number.isNaN(parseInt(obj[index1])) &&
                        !obj[index1].includes('¬~¬')
                      ) {
                        obj[index1] = formatDigits(
                          obj[index1],
                          getDefaultDecimalPlaces
                        )
                      }
                    }
                  }

                  jsonData[columName] = obj[index1]
                })
                dynamicSalesData.push(jsonData)
              })
              setTopSalesData(dynamicSalesData)
              // console.log("Sales", dynamicSalesData);
            } catch (e) {
              topSalesData = []
              setTopSalesData([])
            }
          } else {
            setTopSalesData([])
          }
          //#endregion Top Sales People
        }
      })
      .catch(e => {
        // message.error("Something Went Wrong...");
      })
  }

  //#endregion Api Services
  const GetReportDynamicLink = (key, value) => {
    let reportType =
      key && key != undefined ? key.trim().replace(' ', '').toLowerCase() : ''
    let id =
      value.split('¬~¬')[0] != undefined &&
      !StringIsNullOrEmpty(value.split('¬~¬')[0])
        ? value.split('¬~¬')[0].trim() != '0&'
          ? value
              .split('¬~¬')[0]
              .trim()
              .concat('&_c1c3-444d-4ca7-8c52-9ac1853c44a6')
          : ''
        : ''
    let displayValue =
      value.split('¬~¬')[1] != undefined
        ? value.split('¬~¬')[1].trim()
        : value.split('¬~¬')[0]
    let redirectURL = ''

    if (displayValue.includes('N/A')) {
      displayValue = `No ${key.Value}`
    }

    if (!StringIsNullOrEmpty(id)) {
      switch (reportType) {
        case 'summary':
          redirectURL = ''
          break
        case 'user':
          redirectURL = `/dashboard/setup/users/edit/${id}/1`
          break
        case 'outlet':
          redirectURL = `/Dashboard/setup/outletsandregisters/editoutlet/${id}/1`
          break
        case 'register':
          redirectURL = `/Dashboard/setup/outletsandregisters/editregister/${id}/1`
          break
        case 'customer':
          redirectURL = `/dashboard/customers/addcustomer/${id}`
          break
        case 'customergroup':
          redirectURL = `/dashboard/Customers/customergroup/${id}`
          break
        case 'promotion':
          redirectURL = `/Dashboard/products/promotions/edit/${id}`
          break
        case 'saleschannel':
          redirectURL = ``
          break
        case 'product':
          redirectURL = `/Dashboard/products/main/edit/${id}`

          break
        case 'sku':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        case 'brand':
          // redirectURL = `/dashboard/products/Brands/${id}`;
          redirectURL = `/dashboard/products/main/listing/brandid/${id}`
          break
        case 'supplier':
          redirectURL = `/Dashboard/products/supplier/edit/${getDecryptID(id)}`
          break
        case 'producttype':
          // redirectURL = `/dashboard/products/producttypes/${id}`;
          redirectURL = `/dashboard/products/main/listing/typeid/${id}`
          break
        case 'tag':
          // redirectURL = `/dashboard/products/producttags/${id}`;
          redirectURL = `/dashboard/products/main/listing/tagid/${id}`
          break
        case 'productvariant':
          redirectURL = `/Dashboard/products/main/edit/${id}`
          break
        default:
          redirectURL = ''
          break
      }
    }

    return !StringIsNullOrEmpty(redirectURL) ? (
      <span
        className='dk-text-reporting '
        onClick={() => {
          history.push(redirectURL)
        }}
        style={{ fontWeight: '400' }}
      >
        <div dangerouslySetInnerHTML={{ __html: displayValue }}></div>
      </span>
    ) : (
      <span style={{ fontWeight: '400' }}>{displayValue}</span>
    )
  }
  //#region Charts Json Builder Functions
  const LineChartsJsonBuilder = (periodData, lineData) => {
    let lineChartsData = []
    const viewByOptions = [
      { label: 'Day', value: '29' },
      { label: 'Week', value: '32' },
      { label: 'Month', value: '26' }
    ]
    const LineChartsObj = Object.keys(lineData[0]).map(k => lineData[0][k])

    if (lineData.length > 0 && LineChartsObj && LineChartsObj.length > 0) {
      for (var i = 0; i < periodData.length; i++) {
        let PeriodDate = ''
        if (form.getFieldValue('PeriodID') == '29') {
          PeriodDate = moment(periodData[i].Value.replace('(#)', '')).format(
            'ddd DD'
          )
        }
        if (form.getFieldValue('PeriodID') == '32') {
          PeriodDate = moment(periodData[i].Value.replace('(#)', '')).format(
            'DD MMM'
          )
        }
        if (form.getFieldValue('PeriodID') == '26') {
          PeriodDate =
            periodData[i].Value.replace('(#)', '') + "'" + periodData[i].Year
        }

        let PeriodValue = 0
        // for (var j = 0; j < lineData.length; j++) {
        //   let revData = Object.keys(lineData[j]).map((k) => lineData[j][k]);
        //   const OutletName = revData.shift();
        //   PeriodValue = revData[i]
        //     ? parseFloat(revData[i]) != "NaN"
        //       ? PeriodValue + parseFloat(revData[i])
        //       : PeriodValue
        //     : PeriodValue;
        // }

        PeriodValue =
          LineChartsObj[i] && LineChartsObj[i] != null ? LineChartsObj[i] : '0'
        let lineObj = {
          PeriodDate: PeriodDate,
          PeriodValue: parseFloat(PeriodValue).toFixed(getDefaultDecimalPlaces)
        }
        lineChartsData.push(lineObj)
      }
    } else {
      let lineObj = {
        PeriodDate: '',
        PeriodValue: ''
      }
      lineChartsData.push(lineObj)
    }

    return lineChartsData
  }
  const BarChartsJsonBuilder = barData => {
    let BarChartsData = []

    if (barData.length > 0) {
      for (var i = 0; i < barData.length; i++) {
        let dataObj = Object.keys(barData[i]).map(k => barData[i][k]) // Object.keys(barData[i]).map((k) => barData[i][k]).slice(1).reduce((a,b) =>   (Number(a) || 0) + (Number(b) || 0), 0 );
        const OutletName = dataObj.shift()
        let Value = dataObj.reduce(
          (a, b) => (Number(a) || 0) + (Number(b) || 0),
          0
        )
        let barObj = {
          OutletName:
            OutletName != undefined
              ? OutletName.includes('¬~¬')
                ? OutletName.split('¬~¬')[1]
                : OutletName
              : '',

          Value: parseFloat(Value).toFixed(getDefaultDecimalPlaces)
        }
        BarChartsData.push(barObj)
      }
    } else {
      let tempObj = {
        OutletName: '',
        Value: ''
      }
      BarChartsData.push(tempObj)
    }

    return BarChartsData
  }

  //#endregion Charts Json Builder Functions

  const onFinish = value => {
    let a = value
    // console.log("Search : ", value);
    let outletID = value.Outlet == '0' ? 'ALL' : value.Outlet
    let date = moment(value.Dates).format(dateFormat)
    let periodID = value.PeriodID != undefined ? value.PeriodID : '29'
    // console.log("Outlet Name", value);
    const body = {
      dateTimeTo: date,
      periodId: periodID,
      outlet: outletID
    }

    getBIDashboardReports(body)
  }

  //#region Components
  const DashboardTableComponent = props => {
    return (
      <>
        <div className='div-flow'>
          {props.isLoading ? (
            <Skeleton count={5} height={30} />
          ) : (
            <>
              <Row>
                <Col md={24}>
                  <h2 class='custom-font-weight-500 custom-font-color-black heading-fonts-adjust mb-2 mt-3'>
                    {props.headerName}
                  </h2>
                </Col>
              </Row>
              <Table
                className='gx-table-responsive'
                columns={props.columns}
                dataSource={props.data}
                pagination={false}
                sortDirections={['ascend', 'descend']}
                onChange={handleTableChange}
                footer={() => (props.isFooter ? <FooterSeeMore /> : '')}
              />
            </>
          )}
        </div>
      </>
    )
  }
  function redirectToSalesReport (measureID) {
    let currentDateTime = form.getFieldValue('Dates')
    let fromFormatDate = moment(currentDateTime).format('YYYY-MM-DDT00:00:00')
    let toFormatDate = moment(currentDateTime).format('YYYY-MM-DDT23:59:00')
    let periodID = form.getFieldValue('PeriodID')
    if (periodID == 26) {
      toFormatDate = moment(toFormatDate).format('YYYY-MM-DD')
      fromFormatDate = moment(toFormatDate)
        .startOf('month')
        .format('YYYY-MM-DD')
    }
    if (periodID == 32) {
      toFormatDate = moment(toFormatDate).format('YYYY-MM-DD')
      fromFormatDate = moment(toFormatDate)
        .startOf('isoWeek')
        .format('YYYY-MM-DD')
    }
    if (periodID == 29) {
      toFormatDate = moment(toFormatDate)
        .endOf('day')
        .format('YYYY-MM-DDTHH:mm:ss')
      fromFormatDate = moment(toFormatDate).format('YYYY-MM-DD')
    }
    let URL = `/dashboard/reporting/salesreports?definition={"ReportId":1,"ReportTypeId":41,"MeasureId":${measureID},"DateTimeFrom":"${fromFormatDate}","DateTimeTo":"${toFormatDate.toString()}","PeriodId":${periodID},"IsComparision":0,"ComparisionFrom":"","ComparisionTo":""}`
    history.push(URL)
  }
  const FooterSeeMore = param => {
    return (
      <>
        <div className='custom-text-center'>
          {/* MeasureID 16 for Products */}
          <Button
            className='ant-btn ant-btn-primary'
            onClick={() => redirectToSalesReport(16)}
          >
            <IntlMessages id='reporting.retaildashboard.viewfullreport' />
          </Button>
        </div>
      </>
    )
  }

  const LineChart = props => (
    <ResponsiveContainer width='100%' height={180}>
      <AreaChart
        data={props.data}
        margin={{ top: 0, right: 40, left: 20, bottom: 30 }}
      >
        <Tooltip />
        <XAxis
          dataKey='PeriodDate'
          interval={0}
          angle={45}
          dx={15}
          dy={20}
          axisLine={false}
          minTickGap={-200}
        />
        <defs>
          <linearGradient id='color15' x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor='#38AAE5' stopOpacity={0.8} />
            <stop offset='95%' stopColor='#F5FCFD' stopOpacity={0.8} />
          </linearGradient>
        </defs>
        <Area
          dataKey='PeriodValue'
          strokeWidth={2}
          stackId='2'
          stroke='#009d12'
          fill='#a2cea7'
          fillOpacity={1}
          dot={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  )

  function checkIfDateMoment (from, to, isHour) {
    let returnValue = {
      from: from,
      to: to
    }
    if (moment.isMoment(from) || moment.isMoment(to)) {
      if (moment.isMoment(from)) {
        const fromDate = isHour
          ? moment(from, 'YYYY-MM-DD HH:mm:SS').format('yyyy-MM-DDTHH:mm:ss')
          : moment(from, 'YYYY-MM-DD').format('YYYY-MM-DD')
        returnValue.from = fromDate
      }
      if (moment.isMoment(to)) {
        const toDate = isHour
          ? moment(to, 'YYYY-MM-DD HH:mm:SS').format('yyyy-MM-DDTHH:mm:ss')
          : moment(to, 'YYYY-MM-DD').format('YYYY-MM-DD')
        returnValue.to = toDate
      }
    }
    return returnValue
  }
  function checkPeriod (period) {
    let result = period.includes('month')
      ? 26
      : period.includes('year')
      ? 27
      : period.includes('weekday')
      ? 28
      : period.includes('date')
      ? 29
      : period.includes('quarter')
      ? 30
      : period.includes('time')
      ? 31
      : period.includes('firstofweek')
      ? 32
      : 32
    return result
  }

  const VerticalComposedChart = props => (
    <ResponsiveContainer width='100%' height={200}>
      <ComposedChart
        layout='vertical'
        data={props.data}
        margin={{ top: 10, right: 30, left: 15, bottom: 5 }}
      >
        <XAxis type='number' display={'none'} />
        {/* <YAxis dataKey="name"  position="center" type="category"/> */}
        <YAxis
          orientation='left'
          dataKey='OutletName'
          position='right'
          type='category'
          dx={-5}
        />
        <Tooltip />
        {/* <CartesianGrid stroke='#f5f5f5'/> */}
        {/* <Afr dataKey='amt'  stroke='#FE9E15' fill="#76a27b"/> */}
        <Bar dataKey='Value' barSize={30} fill='#76a27b' />
        {/* <Line dataKey='uv' stroke='#59AA2B'/> */}
      </ComposedChart>
    </ResponsiveContainer>
  )
  const ReportDashboardCard = props => {
    const barChartsData = props.barChartsData
    const lineChartsData = props.lineChartsData

    return (
      <Widget styleName={`gx-card-full`}>
        <div className='gx-d-flex gx-px-3 gx-pt-3'>
          <h3>{props.cardName}</h3>
        </div>
        <div className='gx-actchart gx-pb-5 gx-pl-3'>
          <h4
            className={`mb-0 ${
              props.totalValue <= 0 ? 'dk-text-red' : 'gx-text-black'
            } `}
          >
            {props.isCurrency
              ? getCurrData.currencyCode != null
                ? getCurrData.currencyCode
                : getCurrData.currencyName != null
                ? getCurrData.currencyName
                : getCurrData.currencySymbol
              : ''}{' '}
            {props.totalValue}
          </h4>
          {/* <p className="gx-mb-0">Total income</p> */}
          <div className='gx-d-flex gx-flex-row'>
            <h2
              className={` gx-mb-0 gx-mr-2 gx-fs-lg ${
                props.previousValue <= 0 ? 'dk-text-red' : 'dk-text-green'
              }`}
            >
              {props.previousValue}%{' '}
              <i
                className={`icon  gx-fs-sm ${
                  props.previousValue <= 0 ? 'icon-menu-down' : 'icon-menu-up'
                }`}
              />
            </h2>
            <p
              className={`gx-mb-0 gx-fs-sm  ${
                props.previousValue <= 0 ? 'dk-text-red' : 'dk-text-green'
              }`}
            >
              {'Previous'} {getPeriodName}{' '}
            </p>
          </div>
        </div>

        <VerticalComposedChart data={barChartsData} />
        <LineChart data={lineChartsData} />
        <div
          className='gx-p-3'
          onClick={() => {
            redirectToSalesReport(props.measureID)
          }}
        >
          <span className='gx-text-primary gx-pointer gx-text-uppercase gx-fs-sm'>
            <IntlMessages id='reporting.retaildashboard.viewreport' />
          </span>
        </div>
      </Widget>
    )
  }

  const RetailDashboardStatistics = () => {
    return (
      <>
        <div className='div-flow'>
          <Auxiliary>
            <Row>
              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.revenue' />
                  }
                  totalValue={getRevenueData.TotalValue}
                  previousValue={getRevenueData.PreviousValue}
                  isCurrency={true}
                  barChartsData={getRevenueData.BarChartsData}
                  lineChartsData={getRevenueData.LineChartsData}
                  measureID={ReportMeasures.Revenue}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.salecount' />
                  }
                  totalValue={getSalesCountData.TotalValue}
                  previousValue={getSalesCountData.PreviousValue}
                  isCurrency={false}
                  barChartsData={getSalesCountData.BarChartsData}
                  lineChartsData={getSalesCountData.LineChartsData}
                  measureID={ReportMeasures.SaleCount}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.customercount' />
                  }
                  totalValue={getCustomerCountData.TotalValue}
                  previousValue={getCustomerCountData.PreviousValue}
                  isCurrency={false}
                  barChartsData={getCustomerCountData.BarChartsData}
                  lineChartsData={getCustomerCountData.LineChartsData}
                  measureID={ReportMeasures.CustomerCount}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.grossprofit' />
                  }
                  totalValue={getGrossProftData.TotalValue}
                  previousValue={getGrossProftData.PreviousValue}
                  isCurrency={true}
                  barChartsData={getGrossProftData.BarChartsData}
                  lineChartsData={getGrossProftData.LineChartsData}
                  measureID={ReportMeasures.GrossProfit}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.discounted' />
                  }
                  totalValue={getDiscountData.TotalValue}
                  previousValue={getDiscountData.PreviousValue}
                  isCurrency={true}
                  barChartsData={getDiscountData.BarChartsData}
                  lineChartsData={getDiscountData.LineChartsData}
                  measureID={ReportMeasures.Discounted}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.discountedpercentage' />
                  }
                  totalValue={getDiscountedPercentageData.TotalValue}
                  previousValue={getDiscountedPercentageData.PreviousValue}
                  isCurrency={false}
                  barChartsData={getDiscountedPercentageData.BarChartsData}
                  lineChartsData={getDiscountedPercentageData.LineChartsData}
                  measureID={ReportMeasures.DiscountedPercentage}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.avgsalevalue' />
                  }
                  totalValue={getAverageSaleData.TotalValue}
                  previousValue={getAverageSaleData.PreviousValue}
                  isCurrency={true}
                  barChartsData={getAverageSaleData.BarChartsData}
                  lineChartsData={getAverageSaleData.LineChartsData}
                  measureID={ReportMeasures.AvgSaleValue}
                />
              </Col>

              <Col xl={8} lg={12} md={12} sm={12} xs={24}>
                <ReportDashboardCard
                  cardName={
                    <IntlMessages id='reporting.retaildashboard.avgitemspersale' />
                  }
                  totalValue={getAverageItemPerSaleData.TotalValue}
                  previousValue={getAverageItemPerSaleData.PreviousValue}
                  isCurrency={false}
                  barChartsData={getAverageItemPerSaleData.BarChartsData}
                  lineChartsData={getAverageItemPerSaleData.LineChartsData}
                  measureID={ReportMeasures.AvgItemperSale}
                />
              </Col>
            </Row>
          </Auxiliary>
        </div>
      </>
    )
  }
  const handleTableChange = (pagination, filters, sorter) => {
    const obj = sorter
  }
  //#endregion Components

  //Main Return
  return getIsAllowRead ? (
    <div className='Content-wrapper RetailDashboard-pg div-flow'>
      {checkIsWeb().exist && (
        <Row>
          <Col md={24}>
            <h1 className=''>
              <IntlMessages id='reporting.retaildashboard.retaildashboard' />
            </h1>
          </Col>
        </Row>
      )}

      <Card
        className='gx-card Filters-wrapper No-BoxShadow'
        title={<IntlMessages id='products.main.add.searchfilters' />}
      >
        <Form
          {...formItemLayout}
          form={form}
          name={'SearchForm'}
          className='ant-advanced-search-form product-search-form Filters-Form'
          layout='horizontal'
          onFinish={onFinish}
          initialValues={{ Outlet: '0', PeriodID: '29' }}
        >
          <>
            <Row>
              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom Inner-col-padd-0'
                  name={'PeriodID'}
                  label={<IntlMessages id='reporting.retaildashboard.viewby' />}
                  // onChange={onDateChange}
                >
                  <Radio.Group
                    options={viewByOptions}
                    optionType='button'
                    size='middle
                      '
                  />
                </Form.Item>
              </Col>

              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom Inner-col-padd-0'
                  name={'Dates'}
                  // onChange={onDateChange}
                  label={<IntlMessages id='reporting.retaildashboard.dates' />}
                >
                  <DatePicker
                    className='gx-w-100'
                    defaultValue={moment()}
                    format={dateFormat}
                    disabledDate={current => {
                      let customDate = moment()
                        .add(1, 'days')
                        .format('YYYY-MM-DD')
                      return (
                        current && current > moment(customDate, 'YYYY-MM-DD')
                      )
                    }}
                    inputReadOnly={true}
                  />
                </Form.Item>
              </Col>

              <Col xl={8} lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom Inner-col-padd-0'
                  name={'Outlet'}
                  label={<IntlMessages id='sell.salehistory.out' />}
                >
                  <Select
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                  >
                    <Select.Option key={'0'} value={'0'}>
                      {'All'}
                    </Select.Option>

                    {getReduxStoreOutlets &&
                      getReduxStoreOutlets.length > 0 &&
                      getReduxStoreOutlets.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.outlet}>
                            {e.outlet}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                <Form.Item className='ant-form-item-label-custom Inner-col-padd-0'>
                  <Button
                    className='float-right'
                    htmlType='submit'
                    type='primary'
                    size='large'
                  >
                    <IntlMessages id='reporting.productInventorymovements.search' />
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </>
        </Form>
      </Card>

      {getLoader ? (
        <>
          <Skeleton count={5} height={50} />
        </>
      ) : (
        <>
          <RetailDashboardStatistics />
          <DashboardTableComponent
            isLoading={getLoader}
            headerName={
              <IntlMessages id='reporting.retaildashboard.productssold' />
            }
            columns={getProductSoldColumns}
            data={getProductSoldData}
            isFooter={true}
          />
          <DashboardTableComponent
            isLoading={getLoader}
            headerName={
              <IntlMessages id='reporting.retaildashboard.topsalespeople' />
            }
            columns={getTopSalesColumns}
            data={getTopSalesData}
            isFooter={false}
          />
        </>
      )}
    </div>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default RetailDashboardListing

//#region Comments Un use Code
// const trafficData = [
//   { name: "Page A", income: 200 },
//   { name: "Page B", income: 900 },
//   { name: "Page C", income: 600 },
//   { name: "Page D", income: 1600 },
//   { name: "Page D", income: 900 },
// ];
// const LineChartsdata = [
//   { PeriodDate: "", PeriodValue: 200 },
//   { PeriodDate: "JAN", PeriodValue: 400 },
//   { PeriodDate: "FEB", PeriodValue: 150 },
//   { PeriodDate: "MAR", PeriodValue: 400 },
//   { PeriodDate: "APR", PeriodValue: 1000 },
//   { PeriodDate: "MAY", PeriodValue: 400 },
//   { PeriodDate: "JUN", PeriodValue: 1200 },
//   { PeriodDate: "JUL", PeriodValue: 1000 },
//   { PeriodDate: "AUG", PeriodValue: 800 },
//   { PeriodDate: "SEP", PeriodValue: 750 },
//   { PeriodDate: "OCT", PeriodValue: 1500 },
//   { PeriodDate: "NOV", PeriodValue: 1000 },
//   { PeriodDate: "DEC", PeriodValue: 1500 },
//   { PeriodDate: "", PeriodValue: 500 },
// ];

// const VerticalComposedData = [
//   { name: "Gulistan-e-Johar", price: 500 },
//   { name: "Sadar", price: 300 },
// ];
// const StackedBarData = [
//   { name: "Gulistan-e-Johar", uv: 4000, price: 2400, amt: 2400 },
//   { name: "Sadar", uv: 3000, price: 1398, amt: 2210 },
// ];
// const StackedBarChart = () => (
//   <ResponsiveContainer width="100%" height={200}>
//     <BarChart
//       data={StackedBarData}
//       margin={{ top: 10, right: 0, left: -15, bottom: 0 }}
//     >
//       <XAxis dataKey="name" />
//       <YAxis fill="#76a27b" />
//       <CartesianGrid strokeDasharray="3 3" />
//       <Tooltip />
//       <Legend />
//       <Bar dataKey="price" stackId="a" fill="#76a27b" />
//       <Bar dataKey="uv" stackId="a" fill="#76a27b" />
//     </BarChart>
//   </ResponsiveContainer>
// );

// const productSoldColumns = [
//   {
//     title: <IntlMessages id="reporting.retaildashboard.revenue" />,
//     dataIndex: "productName",
//     key: "productName",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.itemsold" />,
//     dataIndex: "brandName",
//     key: "brandName",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.trend" />,
//     dataIndex: "supplierName",
//     key: "supplierName",
//   },
//   {
//     title: <IntlMessages id="products.main.add.inventory" />,
//     dataIndex: "totalInventoryCount",
//     key: "totalInventoryCount",
//   },
// ];

// const topSalesPeoplecolumns = [
//   {
//     title: <IntlMessages id="reporting.retaildashboard.user" />,
//     dataIndex: "productName",
//     key: "productName",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.revenue" />,
//     dataIndex: "brandName",
//     key: "brandName",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.salecount" />,

//     dataIndex: "supplierName",
//     key: "supplierName",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.itemsold" />,

//     dataIndex: "totalInventoryCount",
//     key: "totalInventoryCount",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.avgsalevalue" />,

//     dataIndex: "totalInventoryCount",
//     key: "totalInventoryCount",
//   },
//   {
//     title: <IntlMessages id="reporting.retaildashboard.avgitemspersale" />,

//     dataIndex: "totalInventoryCount",
//     key: "totalInventoryCount",
//   },
// ];
// async function getProductListing(searchObj) {
//   await ds.getProductList(searchObj).then((types) => {
//     if (types.data.data != null) {
//       let mapped = types.data.data.map((product) => {
//         return {
//           key: product.productID,
//           productName: product.productName,
//           brandID: product.brandID,
//           brandName: product.brandName,
//           supplierID: product.supplierID,
//           supplierName: product.supplierName,
//           totalInventoryCount: product.totalInventoryCount,
//           retailPrice:
//             product.retailPrice != undefined
//               ? parseFloat(product.retailPrice).toFixed(
//                   getDefaultDecimalPlaces
//                 )
//               : "0.00",
//           isActive: product.isActive,
//           createdOn: product.createdOn,
//         };
//       });

//       //  mapped.sort((a, b) => (a.productName > b.productName ? 1 : -1));
//       setProductListingData(mapped);
//       setIsLoading(false);
//       // ;
//       if (types.data.data.length > 0) {
//         let paginationobj = {
//           CurrentPageNo: types.data.data[0].currentPageNo,
//           PageSize: types.data.data[0].pageSize,
//           total: types.data.data[0].totalRecords,
//         };
//         setPagination(paginationobj);
//       }
//     }
//   });
// }

// const [getProductListingData, setProductListingData] = React.useState([]);
// React.useEffect(() => {
//   getProductListing(pagination);
//   //    getProductsData();
// }, []);
// const [pagination, setPagination] = React.useState({
//   CurrentPageNo: 1,
//   PageSize: 10,
// });
// const [options, setOptions] = useState([]);
// const [getSearchProd, setSearchProd] = useState([]);
// const [searchFilterData, setSearchFilterData] = React.useState({
//   CurrentPageNo: 1,
//   PageSize: 10,
// });

// const handleSearch = async (value) => {
//   if (value.length > 1) {
//     let nameArray = [];
//     let searchProducts = {
//       data: {
//         msgCode: "",
//         msgDescription: "",
//       },
//     };
//     await ds
//       .getBookSearchProd(`?keys=${value}`)
//       .then((response) => (searchProducts.data = response.data))
//       .catch((e) => console.log("Product Search Issue", e));

//     if (searchProducts.data.msgCode == "GENERAL_SUCCESS") {
//       if (searchProducts.data.data.length > 0) {
//         setSearchProd(getSearchProd.concat(searchProducts.data.data));
//         nameArray = searchProducts.data.data.map((names) => {
//           const category = names.productName;
//           return {
//             value: category,
//             label: (
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <span
//                   style={{
//                     backgroundColor: "lightcyan",
//                     fontStyle: "oblique",
//                     fontWeight: "bolder",
//                   }}
//                 >
//                   <a>{category}</a>
//                 </span>
//                 <span>
//                   <IntlMessages id="products.addeditpriceprod.searchresult" />
//                 </span>
//               </div>
//             ),
//           };
//         });
//       }
//       setOptions(nameArray);
//     }

//     if (searchProducts.data.msgCode == "GENERAL_ERROR") {
//       message.error(searchProducts.data.msgDescription);
//     }
//   } else {
//     setOptions([]);
//     setSearchProd([]);
//   }
// };
// const onSelect = (value) => {};
// function onDateChange(date, dateString) {
//   //;
//   //console.log(date, dateString);
// }

//#endregion  Comments Un use Code
